import { Flex, Box } from '@mantine/core'
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react'

export default function TestimonialNavigation({
    onPrev,
    onNext,
    isMobile,
}: {
    onPrev: () => void
    onNext: () => void
    isMobile?: boolean | false
}) {
    return (
        <Flex gap={16} mt={12}>
            <Box
                component="button"
                onClick={onPrev}
                style={{
                    width: isMobile ? 50 : 40,
                    height: isMobile ? 50 : 40,
                    borderRadius: '50%',
                    background: 'transparent',
                    border: '1px solid var(--gm-foreground-fg-outline-primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                }}
            >
                <IconArrowLeft color="var(--gm-foreground-fg-highlight)" size={20} />
            </Box>
            <Box
                component="button"
                onClick={onNext}
                style={{
                    width: isMobile ? 50 : 40,
                    height: isMobile ? 50 : 40,
                    borderRadius: '50%',
                    background: 'transparent',
                    border: '1px solid var(--gm-foreground-fg-outline-primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                }}
            >
                <IconArrowRight color="var(--gm-foreground-fg-highlight)" size={20} />
            </Box>
        </Flex>
    )
}
